// extracted by mini-css-extract-plugin
export default {"title":"styles_title__kspi-","subtitle":"styles_subtitle__SIQM6","vid":"styles_vid__YvhOB","vidContainer":"styles_vidContainer__Os6fd"};